import React from "react";
import { Container, Nav, Navbar } from "react-bootstrap";
import { Link } from "react-router-dom";
import myLogo from "../../assets/images/my_logo4.png";

// 🖥️ Desktop Navbar
const DesktopNav = () => (
  <div className="d-none d-lg-block">
    <Navbar expand="lg" className="bg-body-tertiary">
      <Container fluid></Container>
    </Navbar>

    <Navbar>
      <Container className="d-flex justify-content-center py-2">
        <Navbar.Brand as={Link} to="/home">
          <img
            src={myLogo}
            alt="Logo"
            className="img-fluid"
            style={{ height: "100px" }}
          />
        </Navbar.Brand>
      </Container>
    </Navbar>

    <Navbar bg="light" className="border-bottom">
      <Container fluid className="d-flex justify-content-start">
        <h5 className="ps-2 fw-bold mb-0">SPORTS</h5>
      </Container>
    </Navbar>

    <Navbar bg="light">
      <Container fluid>
        <Nav
          className="fw-bold"
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "10px",
            padding: "6px 0",
          }}
        >
          {/* <Nav.Link as={Link} to="/sports/home">
            Home
          </Nav.Link> */}
          <Nav.Link as={Link} to="/sports/cricket">
            Cricket
          </Nav.Link>
          <Nav.Link as={Link} to="/sports/nfl">
            NFL
          </Nav.Link>
          <Nav.Link as={Link} to="/sports/nba">
            NBA
          </Nav.Link>
          <Nav.Link as={Link} to="/sports/golf">
            Golf
          </Nav.Link>
          <Nav.Link as={Link} to="/sports/mlb">
            MLB
          </Nav.Link>
          <Nav.Link as={Link} to="/sports/tennis">
            Tennis
          </Nav.Link>
          <Nav.Link as={Link} to="/sports/soccer">
            Soccer
          </Nav.Link>
          <Nav.Link as={Link} to="/sports/hockey">
            Hockey
          </Nav.Link>
          <Nav.Link as={Link} to="/sports/chess">
            Chess
          </Nav.Link>
        </Nav>
      </Container>
    </Navbar>
  </div>
);

// 📱 Mobile Navbar
const MobileNav = () => (
  <div className="d-lg-none">
    {/* 🔹 First Line: Logo */}
    <div style={{ background: "#fff", borderBottom: "1px solid #ddd" }}>
      <Navbar.Brand as={Link} to="/home">
        <Container fluid className="py-2 d-flex align-items-center">
          <img
            src={myLogo}
            alt="Logo"
            className="img-fluid"
            style={{ height: "40px" }}
          />
        </Container>
      </Navbar.Brand>
    </div>

    {/* 🔹 Second Line: Scrollable Categories */}
    <div
      style={{
        overflowX: "auto",
        whiteSpace: "nowrap",
        borderBottom: "1px solid #ddd",
        WebkitOverflowScrolling: "touch",
      }}
    >
      <Nav
        className="fw-bold text-secondary"
        style={{
          display: "inline-flex",
          flexWrap: "nowrap",
          gap: "20px",
          padding: "10px",
          fontSize: "14px",
        }}
      >
        <Nav.Link as={Link} className="text-secondary" to="/sports/cricket">
          Cricket
        </Nav.Link>
        <Nav.Link as={Link} className="text-secondary" to="/sports/nfl">
          NFL
        </Nav.Link>
        <Nav.Link as={Link} className="text-secondary" to="/sports/nba">
          NBA
        </Nav.Link>
        <Nav.Link as={Link} className="text-secondary" to="/sports/golf">
          Golf
        </Nav.Link>
        <Nav.Link as={Link} className="text-secondary" to="/sports/mlb">
          MLB
        </Nav.Link>
        <Nav.Link as={Link} className="text-secondary" to="/sports/tennis">
          Tennis
        </Nav.Link>
        <Nav.Link as={Link} className="text-secondary" to="/sports/soccer">
          Soccer
        </Nav.Link>
        <Nav.Link as={Link} className="text-secondary" to="/sports/hockey">
          Hockey
        </Nav.Link>
        <Nav.Link as={Link} className="text-secondary" to="/sports/chess">
          Chess
        </Nav.Link>
      </Nav>
    </div>
  </div>
);

// 🌐 Main SportsNavBar Component
const SportsNavBar = () => (
  <div>
    <DesktopNav />
    <MobileNav />
  </div>
);

export default SportsNavBar;
